import React from 'react'
import { MwInputText } from '../../ui'
import { useTranslation } from 'react-i18next';

const AdvancedForm = ({
    errors,
    customerAccountNo,
    setCustomerAccountNo,
    customerVatNo,
    setCustomerVatNo,
    limitCredit,
    setLimitCredit
}) => {
    const [t] = useTranslation("global");
    return (
        <>
        <div className='py-2'>
            <MwInputText 
                label={t("vendors.taxNumber")}
                id='customerVatNo' 
                value={customerVatNo} 
                onChange={(e)=>setCustomerVatNo(e.target.value)} />
        </div>
        <div className='py-2'>
            <MwInputText 
                label={t("vendors.accountNumber")}
                id='customerAccountNo' 
                value={customerAccountNo} 
                onChange={(e)=>setCustomerAccountNo(e.target.value)} />
        </div>
        <div className='py-2'>
            <MwInputText 
                label={t("vendors.creditLimit")}
                id='limitCredit' 
                inputType='Number'
                value={limitCredit} 
                invalid={!!errors.limitCredit}
                invalidMsg={errors.limitCredit}
                onChange={(e)=>setLimitCredit(e.target.value)} />
        </div>
    </>
    )
}

export default AdvancedForm